import handleSlider from '../sliders/handle-slider';

$('.js-tabs').on('click', '.tabs__nav a', function(event) {
  const $this = $(this);
  const $element = $($($this).attr('href'));

  if (!$element.length) {
    return;
  }

  $element
    .add($this.parent())
    .addClass('is-current')
    .siblings('.is-current')
    .removeClass('is-current');

  if ($element.find('.js-slider').length > 0 && ! $element.find('.js-slider').hasClass('slick-initialized')) {
    handleSlider($element.find('.js-slider'))
  }

  event.preventDefault();
});
